import React, { useEffect, useState } from 'react'
import { Breadcrumb, Col, Row } from 'react-bootstrap';
import Card from '../../UI/Card/Card';
import Graybg from '../../UI/Graybg';
import SecBTN from '../../UI/SecBTN';
import Select from '../../UI/Select/Select';
import classes from './QuestionList.module.css'
import userService from '../../app/services/user.service';
import Loader from '../../UI/loader/loader';
import { Link, useNavigate } from 'react-router-dom';
import { isEmpty, linkReplaceFn } from '../../utils/custom_funtions';
import Toast from '../../UI/Toast/Toast';
import { toast } from 'react-toastify';
import Modals from '../../UI/Modals/Modals';


export const QuestionListOptions = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));
  const profile_id = user.data.user.profile_id;
  const [reportData, setReportData] = useState(null);
  const [pages, setPages] = useState(1);
  const [showEntries, setShowEntries] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const initialState = {
    subjectList: [],
    topicList: [],
    subTopicList: [],
    toughnessList: [],
    ansTypeList: [],
    selectedSubject: '',
    selectedTopic: '',
    selectedSubTopic: '',
    selectedToughness: '',
    quesTypeList: [],
    selectedQuesType: '',
    selectedAnsType: '',
    questionList: [],
    limit: 1,
  }
  const getPersistableState = (s) => ({
    selectedSubject: s.selectedSubject,
    selectedTopic: s.selectedTopic,
    selectedSubTopic: s.selectedSubTopic,
    selectedToughness: s.selectedToughness,
    selectedQuesType: s.selectedQuesType,
    selectedAnsType: s.selectedAnsType,
    limit: s.limit,
  });

  const [state, setState] = useState(() => {
    const savedState = localStorage.getItem('questionListState');
    if (!savedState) return initialState;
    try {
      const parsed = JSON.parse(savedState);
      return { ...initialState, ...getPersistableState(parsed) };
    } catch (e) {
      localStorage.removeItem('questionListState');
      return initialState;
    }
  });



  const getSubjectList = () => {
    setIsLoading(true)
    userService.getSubjectList()
      .then(res => {
        setState(prev => {
          return { ...prev, subjectList: res.data.data }
        })
        setIsLoading(false)
      })
      .catch(err => {
        console.log(err);
        setIsLoading(false)
      })
  }
  const getTopicList = (subId) => {
    setIsLoading(true)
    userService.getTopicListBySid(subId)
      .then(res => {
        const topiclist = res.data.data.filter(topic => topic.status == 1 && topic.topic_sequence !== null)
        setState(prev => {
          return { ...prev, topicList: topiclist, subTopicList: [], selectedTopic: '', selectedSubTopic: '' }
        })
        setIsLoading(false)
      })
      .catch(err => {
        console.log(err);
        setState(prev => {
          return { ...prev, topicList: [], subTopicList: [], selectedTopic: '', selectedSubTopic: '' }
        })
        setIsLoading(false)
      })
  }
  const getSubTopicList = (tid) => {
    setIsLoading(true)
    userService.getSubTopicByTid(tid)
      .then(res => {
        const subtopiclist = res.data.data.filter(subtopic => subtopic.status == 1 && subtopic.sub_topic_sequence !== null)
        console.log(res.data);
        setState(prev => {
          return { ...prev, subTopicList: subtopiclist, selectedSubTopic: '' }
        })
        setIsLoading(false)
      })
      .catch(err => {
        console.log(err);
        setState(prev => {
          return { ...prev, subTopicList: [] }
        })
        setIsLoading(false)
      })
  }
  const getQuesTypeList = () => {
    setIsLoading(true);
    userService
      .getQuesType()
      .then((res) => {
        setState((prev) => {
          return { ...prev, quesTypeList: res.data.data };
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  const getAnsTypeList = () => {
    setIsLoading(true);
    userService
      .getAnsType()
      .then((res) => {
        setState((prev) => {
          return { ...prev, ansTypeList: res.data.data };
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  const getToughnessList = () => {
    setIsLoading(true)
    userService.getToughness()
      .then(res => {
        setState(prev => {
          return { ...prev, toughnessList: res.data.data }
        })
        setIsLoading(false)
      })
      .catch(err => {
        console.log(err);
        setIsLoading(false)
      })
  }
  useEffect(() => {
    getSubjectList();
    getToughnessList();
    getQuesTypeList();
    getAnsTypeList();
  }, [])
  const inputHandler = (data) => {
    setState((prev) => {
      return { ...prev, ...data };
    });
  }
  const searchHandler = (page = 1) => {
    setIsLoading(true)
    const body = {
      sub_id: state.selectedSubject,
      topic_id: state.selectedTopic,
      sub_topic_id: state.selectedSubTopic,
      toughness_id: state.selectedToughness,
      qtype_id: state.selectedQuesType,
      anstype_id: state.selectedAnsType,
      page: page,
    }
    console.log(body);
    userService.getQuestionListOptions(body)
      .then(res => {
        setIsLoading(false)
        setState(prev => {
          return { ...prev, questionList: res.data.result }
        })
      })
      .catch(err => {
        setIsLoading(false)
        setState(prev => {
          return { ...prev, questionList: [] }
        })
        toast.error("No questions found !!")
        console.log(err)
      })
  }

  const openFacultyReport = (qid) => {
    setIsLoading(true);
    userService
      .getQuestionAttemptData([qid])
      .then((res) => {
        setIsLoading(false);
        setReportData(res.data[0]);
        setShowReportModal(true);
        console.log(res.data[0]);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error("Failed to load faculty report");
        console.log(err);
      });
  };

  const clearDataHandler = () => {

    localStorage.removeItem('questionListState');

    setState(initialState);
    window.location.reload();
  };

  const navigate = useNavigate()
  const getOverviewData = (searchQid) => {
    userService
      .getOverviewData(searchQid)
      .then((res) => {
        navigate(`/editQuestion/edit/${searchQid}`)
      })
      .catch((err) => {
        console.log(err);
        toast.error(`Data not found for this QID`)
      });
  };
  const qidSubmit = e => {
    e.preventDefault();
    console.log(e.target[0].value)
    getOverviewData(e.target[0].value)
  }
  return (
    <>
      <Toast />
      {isLoading && <Loader />}
      <div className="section">
        <div className="d-flex justify-content-between align-items-center h-100">
          <div>
            <h4>Edit Question</h4>
            <Breadcrumb>
              <Breadcrumb.Item active>Question</Breadcrumb.Item>
              <Breadcrumb.Item active>Question List</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>

        <Graybg>
          <Card className={classes.filter}>
            <Row>
              <Col lg={6} sm={12} className="my-1">
                <Select
                  value={state.selectedSubject}
                  onChange={(e) => {
                    inputHandler({ selectedSubject: e.target.value })
                    getTopicList(e.target.value);
                  }}
                >
                  <option value="">
                    Select Subject
                  </option>
                  {state.subjectList.map((subject) => {
                    return (
                      <option key={subject.sub_id} value={subject.sub_id}>
                        {subject.sub_name}
                      </option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={6} sm={12} className="my-1">
                <Select
                  value={state.selectedTopic}
                  onChange={(e) => {
                    inputHandler({ selectedTopic: e.target.value })
                    getSubTopicList(e.target.value);
                  }}
                >
                  <option value="" >
                    Select Topic
                  </option>
                  {state.topicList.map((topic) => {
                    return (
                      <option key={topic.topic_id} value={topic.topic_id}>
                        {topic.topic_name}
                      </option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={6} sm={12} className="my-1">
                <Select
                  value={state.selectedSubTopic}
                  onChange={(e) => {
                    inputHandler({ selectedSubTopic: e.target.value })
                  }}
                >
                  <option value="">
                    Select Sub-topic
                  </option>
                  {state.subTopicList.map((subtopic) => {
                    return (
                      <option
                        key={subtopic.sub_topic_id}
                        value={subtopic.sub_topic_id}
                      >
                        {subtopic.Sub_topic_name}
                      </option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={6} sm={12} className="my-1">
                <Select
                  value={state.selectedQuesType}
                  onChange={(e) => {
                    inputHandler({ selectedQuesType: e.target.value })
                  }}
                >
                  <option value="" >
                    Select Question type
                  </option>
                  {state.quesTypeList.map((quesType) => {
                    return (
                      <option value={quesType.type_id}>{quesType.type}</option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={6} sm={12} className="my-1">
                <Select
                  value={state.selectedToughness}
                  onChange={(e) => {
                    inputHandler({ selectedToughness: e.target.value })
                  }}
                >
                  <option value="" >
                    Select Toughness
                  </option>
                  {state.toughnessList.map(({ toughness_id, toughness }) => {
                    return (
                      <option key={toughness_id} value={toughness_id}>
                        {toughness}
                      </option>
                    );
                  })}
                </Select>
              </Col>
              <Col lg={6} sm={12} className="my-1">
                <Select value={state.selectedAnsType}
                  onChange={(e) => {
                    inputHandler({ selectedAnsType: e.target.value })
                  }}
                >
                  <option value='' >
                    Select Answer type
                  </option>
                  {state.ansTypeList.map((ansType) => {
                    return <option value={ansType.answer_id}>{ansType.answer_type}</option>
                  })}
                </Select>
              </Col>
            </Row>
            <div className="mt-3 d-flex  justify-content-center">
              <SecBTN className="sec-btn1 mx-2" onClick={() => searchHandler()}>Search</SecBTN>
              <SecBTN className="sec-btn1 mx-2" onClick={clearDataHandler} >Clear Data</SecBTN>
            </div>
          </Card>
          {/* <DataTable /> */}
          {!isEmpty(state.questionList) ? (
            <>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  Show{" "}
                  <select
                    value={showEntries}
                    onChange={(e) => {
                      setShowEntries(+e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={"ALL"}>ALL</option>
                  </select>{" "}
                  entries
                </div>
                <p className="mb-0 small">
                  Showing <b>{Math.min(showEntries, state.questionList.length)}</b> out of <b>{state.questionList.length}</b> entries
                </p>
              </div>
              <div className="table-responsive mb-3">
                <table className="table table-bordered mt-2 mb-0">
                  <thead className={classes.tblheader}>
                    <tr>
                      <th>QID</th>
                      <th>Question</th>

                      <th>Options</th>
                      {profile_id !== 10 && (
                        <th>Action</th>
                      )}

                      <th>Reports</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.questionList
                      .slice((currentPage - 1) * showEntries, (currentPage - 1) * showEntries + showEntries)
                      .map((qList) => {
                        return (
                          <tr key={qList.qid}>
                            <th scope="row">{qList.qid}</th>
                            <td>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: linkReplaceFn(qList?.q_text),
                                }}
                              />
                            </td>

                            <td>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: linkReplaceFn(qList?.options),
                                }}
                              />
                            </td>
                            {profile_id !== 10 && (
                              <td><Link to={`/editQuestion/edit/${qList.qid}`}><SecBTN className='sec-btn1'>Edit</SecBTN></Link></td>
                            )}

                            <td style={{ width: '15%' }}>
                              <SecBTN
                                className='sec-btn1'
                                onClick={() => openFacultyReport(qList.qid)}
                              >
                                Faculty Report
                              </SecBTN>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
              <div className='d-flex justify-content-between'>
                <SecBTN className="sec-btn1" disabled={currentPage === 1} onClick={() => {
                  if (currentPage === 1) {
                    setPages(pages - 1);
                    searchHandler(pages - 1);
                  } else {
                    setCurrentPage(currentPage - 1);
                  }
                }}>Prev</SecBTN>
                <SecBTN className="sec-btn1"
                  onClick={() => {
                    if (currentPage * showEntries >= state.questionList.length) {
                      setPages(pages + 1);
                      searchHandler(pages + 1);
                      setCurrentPage(1);
                    } else {
                      setCurrentPage(currentPage + 1);
                    }
                  }}>Next</SecBTN>
              </div>
            </>
          )
            : (<div className="table-responsive mb-3">
              <table className="table table-bordered mt-2 mb-0">
                <thead className={classes.tblheader}>
                  <tr>
                    <th>QID</th>
                    <th>Question</th>

                    <th>Options</th>
                    {profile_id !== 10 && (
                      <th>Action</th>
                    )}

                    <th>Reports</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={5} className='text-center'>No data available.</td>
                  </tr>


                </tbody>
              </table>
            </div>
            )
          }

          <Modals
            show={showReportModal}
            onHide={() => setShowReportModal(false)}
            size="lg"
          >
            <h5 className="mb-3">Faculty Report</h5>

            {reportData ? (
              <div className="row text-center">

                <div className="col-md-4 mb-3">
                  <div className="p-3 border rounded bg-light">
                    <h6>Total Attempt</h6>
                    <h4>{reportData.TotalAttept}</h4>
                  </div>
                </div>

                <div className="col-md-4 mb-3">
                  <div className="p-3 border rounded bg-success text-white">
                    <h6>Correct Attempt</h6>
                    <h4>{reportData.CorrectAttempt}</h4>
                    <small>Score: {reportData.Correctscore}%</small>
                  </div>
                </div>

                <div className="col-md-4 mb-3">
                  <div className="p-3 border rounded bg-danger text-white">
                    <h6>Incorrect Attempt</h6>
                    <h4>{reportData.IncorrectAttempt}</h4>
                    <small>Score: {reportData.Incorrectscore}%</small>
                  </div>
                </div>

                <div className="col-md-4 mb-3">
                  <div className="p-3 border rounded bg-warning">
                    <h6>Unattempted</h6>
                    <h4>{reportData.UnAttempt}</h4>
                    <small>Score: {reportData.Unattemptscore}%</small>
                  </div>
                </div>

              </div>
            ) : (
              <p>No data available.</p>
            )}
          </Modals>
        </Graybg>
      </div>
    </>
  );
}


